module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-teatopics-bottom-01.2.1d5ca7ba.jpg";